/**
 * Escapes a value for HTML text and quoted attribute values. Falsy values (including 0) render as
 * an empty string.
 *
 * @param {unknown} value
 * @returns {string}
 */
export function escapeHtml(value) {
    if (!value) return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
